import {
  STORE_FATCA_DETAILS,
  STORE_INVESTMENT_DETAILS,
  STORE_SCHEME_DETAILS,
  STORE_APPLICANT_PARAMS,
  STORE_SCHEME_PARAMS,
  STORE_INVESTMENT_PARAMS,
  STORE_NOMINEE_DETAILS,
  GET_NOMINEE_DETAILS_SUCESS,
  GET_BANK_DETAILS_SUCESS,
  STORE_ADDRESS_SUCESS,
  STORE_PAN,
  CLEARING_FIRST_TIME_INVETOR_JOURNEY_SUCCESS,
} from "../types"; 

const initialState = {
  fatcaDetails: {},
  nomineDetails: {},
  getnomineeDetails: {},
  getbankDetails: {},
  investmentDetails: {},
  schemeDetails: {},
  applicantparams: {},
  schemeparams: {},
  investmentparams: {},
  address: {},
  store_pan: {},
};

export function newinvestor(state = initialState, action) {
  switch (action.type) {
    case STORE_FATCA_DETAILS:
      return { ...state, fatcaDetails: action.body };
    case STORE_NOMINEE_DETAILS:
      return { ...state, nomineDetails: action.body };
    case STORE_INVESTMENT_DETAILS:
      return { ...state, investmentDetails: action.body };
    case STORE_SCHEME_DETAILS:
      return { ...state, schemeDetails: action.body };
    case STORE_APPLICANT_PARAMS:
      return { ...state, applicantparams: action.body };
    case STORE_SCHEME_PARAMS:
      return { ...state, schemeparams: action.body };
    case STORE_INVESTMENT_PARAMS:
      return { ...state, investmentparams: action.body };
    case GET_NOMINEE_DETAILS_SUCESS:
      return { ...state, getnomineeDetails: action.body };
    case GET_BANK_DETAILS_SUCESS:
      return { ...state, getbankDetails: action.body };
    case STORE_ADDRESS_SUCESS:
      return { ...state, address: action.body };
    case STORE_PAN:
      return { ...state, store_pan: action.body };
    case CLEARING_FIRST_TIME_INVETOR_JOURNEY_SUCCESS:
      return { ...initialState }; 
    default:
      return state;
  }
}
